import React, { useContext, useState, useEffect } from "react";
import FormDataContext from "integrations/contexts/FormDataContext";
import { GCP } from "@graylog/enterprise-api";
import formValidation from "./utils/formValidation";
import { renderOptions } from "../common/Options";
import FormWrap from "../common/FormWrap";
import ValidatedInput from "../common/ValidatedInput";
import handleFileUpload from "../helpers/fileReader";
const StepAuthorize = ({ onSubmit, onChange }) => {
  const [regions, setRegions] = useState([]);
  useEffect(() => {
    GCP.getGCPRegions().then((response) => {
      const respRegions = Object.keys(response).map((key) => ({ label: response[key] }));
      setRegions(respRegions);
    });
  }, []);
  const { formData } = useContext(FormDataContext);
  const isFormValid = formValidation.isFormValid(["gcpName", "projectId", "clientId", "serviceAccountKey"], formData);
  const onFileUpload = (e) => {
    e.persist();
    handleFileUpload(e.target.files[0], (fileName, fileContent) => onChange(e, { fileName, fileContent }));
  };
  const accountKeyHelpText = formData.serviceAccountKey && formData.serviceAccountKey.fileName ? `Currently using file: ${formData.serviceAccountKey.fileName}.` : "Service account key JSON.";
  return /* @__PURE__ */ React.createElement(FormWrap, { onSubmit, buttonContent: "Verify & Proceed", disabled: isFormValid, title: "", description: "" }, /* @__PURE__ */ React.createElement(
    ValidatedInput,
    {
      id: "gcpName",
      type: "text",
      fieldData: formData.gcpName,
      onChange,
      placeholder: "Input Name",
      label: "Input Name",
      autoComplete: "off",
      help: "Select a name of your new input that describes it.",
      required: true
    }
  ), /* @__PURE__ */ React.createElement(
    ValidatedInput,
    {
      id: "projectId",
      type: "text",
      fieldData: formData.projectId,
      onChange,
      label: "Project ID",
      help: "The GUID of the project to which the logs belong.",
      autoComplete: "off",
      required: true
    }
  ), /* @__PURE__ */ React.createElement(
    ValidatedInput,
    {
      id: "clientId",
      type: "text",
      onChange,
      fieldData: formData.clientId,
      help: "The GUID of your application.",
      label: "Application (client) ID",
      required: true
    }
  ), /* @__PURE__ */ React.createElement(
    ValidatedInput,
    {
      id: "serviceAccountKey",
      type: "file",
      onChange: onFileUpload,
      fieldData: formData.serviceAccountKey,
      label: "Service account key",
      help: accountKeyHelpText,
      accept: ".json",
      required: true
    }
  ), /* @__PURE__ */ React.createElement(
    ValidatedInput,
    {
      type: "select",
      id: "gcpRegion",
      onChange,
      fieldData: formData.gcpRegion,
      help: "Choose the region where the Bigquery dataset can be created (optional).",
      label: "BigQuery Dataset Region"
    },
    renderOptions(regions, "Select a region", false)
  ));
};
export default StepAuthorize;
